import React, { useState } from "react";
import { Menu, MenuItem, IconButton, Box, Typography } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "nb", flag: "no", labelKey: "language.norwegian" },
  { code: "en", flag: "us", labelKey: "language.english" },
  { code: "sv", flag: "se", labelKey: "language.swedish" },
  { code: "da", flag: "dk", labelKey: "language.danish" },
];

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    handleClose();
  };

  const currentLang = i18n.language === "no" ? "nb" : i18n.language;

  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleClick}
        aria-controls="language-menu"
        aria-haspopup="true"
        aria-label={t("language.selectLanguage")}
      >
        <LanguageIcon />
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {LANGUAGES.map(({ code, flag, labelKey }) => (
          <MenuItem
            key={code}
            onClick={() => changeLanguage(code)}
            selected={currentLang === code}
          >
            <Box
              component="img"
              src={`https://flagcdn.com/w40/${flag}.png`}
              alt=""
              sx={{ width: 24, height: 16, mr: 1.5, borderRadius: 0.5 }}
            />
            <Typography variant="body2">{t(labelKey)}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
